import React from 'react'
import { RadioVariant } from './../../../models/types/radio-variant';

interface RadioProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  variant?: RadioVariant,
  r2?: boolean,
  type?: "dot" | "tick",
  isActive?: boolean,
  description?: JSX.Element | string
  onClick?: () => void,
  gap?: number;
  disabled?: boolean;
}

const isVariantDefaultOrReverse = (variant?: RadioVariant) => {
  return (variant === "default" || variant === "reverse");
}
const getDisabled = (disabled: boolean) => disabled ? "disabled" : "";

function Radio({ gap = 10, type = "dot", variant = "default", isActive = false, disabled = false, ...props }: RadioProps) {

  const handleClick = () => {
    if (props.onClick && !disabled) {
      props.onClick();
    }
  };

  const checkActiveDisabledR2 = () => {
    if (isActive && disabled) {
      return "polymer-radio-form__active-disabled";
    } else if (isActive) {
      return "polymer-radio-form__active";
    } else if (disabled) {
      return "polymer-radio-form__disabled";
    } else {
      return "";
    }
  }

  return (
    <div
      className={`${props.r2 ? "polymer-radio-form__r2" : "polymer-radio-form"} ${props.r2 && checkActiveDisabledR2()} `}
      {...props.r2 ? { onClick: handleClick } : null}
      style={{ gap: gap, flexDirection: (variant === "reverse") ? 'row-reverse' : undefined }}>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ alignSelf: "center" }}>
          <div  {...props.r2 ? null : { onClick: handleClick }}
            className={`polymer-radio-form__icon
            ${isActive && (type === "dot") ? 'active' : getDisabled(disabled)} 
            ${isActive && (type === "tick") ? 'active-tick' : getDisabled(disabled)}`}
          >

            {type === "dot" && (isVariantDefaultOrReverse(variant)) && isActive && <div className={`polymer-radio-form__icon-active icon_${getDisabled(disabled)}`} />}
            {type === "tick" && (isVariantDefaultOrReverse(variant)) && isActive &&
              <div className='polymer-radio-form__icon-active-tick'>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>}

          </div>
        </div>
        {props.description && <div className='polymer-radio-form__description' >{props.description ? props.description : undefined}</div>}
      </div>
    </div >)


  // return (
  //   <div className='polymer-radio-form' style={{ gap: gap, flexDirection: variant === "reverse" ? 'row-reverse' : undefined }}>
  //     <div style={{ display: "flex", flexDirection: "row" }}>
  //       <div style={{ flex: 0, alignSelf: "center" }}>
  //         <div onClick={() => {
  //           if (props.onClick && !disabled) {
  //             props.onClick();
  //           }
  //         }} className={`polymer-radio-form__icon 
  //           ${(isVariantDefaultOrReverse(variant)) && isActive && type === "dot" ? 'active' : getDisabled(disabled)} 
  //           ${(isVariantDefaultOrReverse(variant)) && isActive && type === "tick" ? 'active-tick' : getDisabled(disabled)}`}
  //         >

  //           {type === "dot" && (isVariantDefaultOrReverse(variant)) && isActive && <div className={`polymer-radio-form__icon-active icon_${getDisabled(disabled)}`} />}
  //           {type === "tick" && (isVariantDefaultOrReverse(variant)) && isActive &&
  //             <div className='polymer-radio-form__icon-active-tick'>
  //               <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  //                 <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  //               </svg>
  //             </div>}

  //         </div>
  //       </div>
  //       {props.description && <div className='polymer-radio-form__description' >{props.description ? props.description : undefined}</div>}
  //     </div>
  //   </div>
  // )
}

export default Radio